import i18n from "../../i18n";

// Mirrors the backend's DeletionErrorCode. Only whitelisted codes are
// translated; anything else falls back to humanizeImportError on the raw text.
export const DELETE_ERROR_CODES = [
  "DELETE_CHILDREN_FAILED",
  "DELETE_SCENARIOS_FAILED",
  "DELETE_PROGRAM_PARTIAL",
  "DELETE_PROJECT_PARTIAL",
  "DELETE_TARGET_NOT_FOUND",
  "DELETE_CONCURRENT_MODIFICATION",
  "DELETE_CHILD_BUSY",
  "DELETE_DATABASE_ERROR",
  "DELETE_UNKNOWN",
];

const ITEM_KIND_TERMS = {
  PROGRAM: "term.program",
  PROJECT: "term.project",
  SCENARIO: "term.scenario",
};

function termParams() {
  return {
    project: i18n.t("term.project").toLowerCase(),
    program: i18n.t("term.program").toLowerCase(),
  };
}

/** { message, actionHint } for a known backend deletion code, else null. */
export function translateDeleteError(code, params) {
  if (!DELETE_ERROR_CODES.includes(code)) return null;
  const values = { ...termParams(), ...(params || {}) };
  return {
    message: i18n.t(`progressNotifications.deleteErrors.${code}.message`, values),
    actionHint: i18n.t(`progressNotifications.deleteErrors.${code}.actionHint`, values),
  };
}

/** "Contrat : Contrat 03" built from the backend's queue item kind + bare name, else null. */
export function deleteItemLabel(kind, name) {
  const term = ITEM_KIND_TERMS[kind];
  if (!term || !name) return null;
  return i18n.t("progressNotifications.itemLabel", {
    kind: i18n.t(term),
    name,
    defaultValue: `${i18n.t(term)}: ${name}`,
  });
}
